import { IComponentController, IComponentOptions } from 'angular';
import { tnEquals } from '../../../functions';
import template from './tn-select-2.html';

export interface TnSelect2Option {
    label: string;
    value: string | number;
}

export class TnSelect2Component implements IComponentController {
    // bindings
    value?: unknown;
    options?: TnSelect2Option[] = [];
    placeholder?;
    onChange?: ({ value: unknown }) => void;

    // local state
    _isOpen = false;
    _selected?: TnSelect2Option;
    _selectedText = this._selected ? this._selected.label : this.placeholder;

    $onInit(): void {
        const option = this.options?.find((o) => tnEquals(o.value, this.value));
        this.select(option);
    }

    toggle(): void {
        this._isOpen = !this._isOpen;
    }

    select(option?: TnSelect2Option): void {
        this._selected = this._selected === option ? undefined : option;
        this._selectedText = this._selected
            ? this._selected.label
            : this.placeholder;
        if (tnEquals(this._selected?.value, this.value)) return;
        this.onChange && this.onChange({ value: this._selected?.value });
    }
}

export const TnSelect2ComponentOptions: IComponentOptions = {
    bindings: {
        value: '<',
        options: '<',
        placeholder: '<',
        onChange: '&',
    },
    controller: TnSelect2Component,
    template,
};
